import { ReactNode, useId } from 'react';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: ReactNode;
  id?: string;
}

export function ToggleRow({ checked, onChange, label, id }: Props) {
  const reactId = useId();
  const inputId = id ?? reactId;
  return (
    <label
      htmlFor={inputId}
      className={`flex items-center justify-between px-3 py-3 rounded-xl border border-[var(--line,rgba(15,30,51,0.08))] bg-white text-sm font-semibold cursor-pointer transition-colors hover:bg-[var(--canvas,#F5F7FA)] mb-1.5 ${
        checked ? 'border-[var(--brand-primary,#22D3EE)] bg-[rgba(34,211,238,0.04)]' : ''
      }`}
    >
      <span className="text-[var(--ink,#0F1E33)]">{label}</span>
      <span className="relative inline-block">
        <input
          id={inputId}
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span
          aria-hidden="true"
          className={`block w-9 h-5 rounded-full transition-colors ${checked ? 'bg-[var(--brand-primary,#22D3EE)]' : 'bg-[rgba(15,30,51,0.16)]'}`}
        />
        <span
          aria-hidden="true"
          className="block absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full transition-transform"
          style={{ transform: checked ? 'translateX(16px)' : 'translateX(0)' }}
        />
      </span>
    </label>
  );
}
